import PropTypes from "prop-types";
import licenses from "../../storage/web/public/licenses.json";

import { Modal, Paragraph1 } from "../../components";

import { PackageTable } from "./components/PackageTable";
import { LicensesModalContainer, LicensesSection } from "./styled";
import { strCode } from "../../consts";
import { t } from "../../services";
import { LicenseHeader } from "./components/LicenseHeader";

const LicensesListModal = ({ active, setActive }) => {
  return (
    <Modal
      active={active}
      setActive={setActive}
      closable={true}
      Container={LicensesModalContainer}
      title={t(strCode.LICENSES_TABLE_TITLE)}>
      {Object.entries(licenses).map(([license, packages], id) => {
        return <PackageTable key={id} heading={license} data={packages} />;
      })}
      <LicensesSection>
        <LicenseHeader heading={"MIT"} />
        <Paragraph1 dangerouslySetInnerHTML={{ __html: t(strCode.MIT_DEFINITION) }} />
      </LicensesSection>
    </Modal>
  );
};

LicensesListModal.propTypes = {
  active: PropTypes.bool,
  setActive: PropTypes.func
};

export default LicensesListModal;
